import { TIMEZONE_OFFSET } from "@common/constants/general/date-time";

export const UTC_OFFSET_DEFAULT = -TIMEZONE_OFFSET;
